import { render, staticRenderFns } from "./TournamentView.vue?vue&type=template&id=2d58470d&"
import script from "./TournamentView.vue?vue&type=script&lang=js&"
export * from "./TournamentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports